import { callApiToServer } from "../callApi";

export async function deleteOpenApiUser(
  authtoken,
  flag,
  userId,
  skipNumber,
  limitNumber,
  searchText,
  cityId = ""
) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      search_text: searchText,
    });

    let endUrl = `v1/auth/delete-user/${userId}/${skipNumber}/${limitNumber}?city=${cityId}&account_type=${flag}`;
    let responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
